import React from 'react';
import {graphql} from 'gatsby';

import * as styles from './findAPlan.module.scss';
import {PageFindAPlanFragment} from '@graphql-types';
import {useNow} from '@src/components/NowProvider';
import CountyForm from '@src/components/PlanFinder/CountyForm';
import {activePlanYear} from '@src/utils';

interface FindAPlanProps {
  data: PageFindAPlanFragment;
  planBenefitPackages: React.ComponentProps<
    typeof CountyForm
  >['planBenefitPackages'];
  ssaCounties: React.ComponentProps<typeof CountyForm>['ssaCounties'];
  supportedCounties: React.ComponentProps<
    typeof CountyForm
  >['supportedCounties'];
}

const FindAPlan = (props: FindAPlanProps) => {
  const now = useNow();

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.header}>{props.data.primary.heading.text}</h2>
      <CountyForm
        activePlanYear={activePlanYear(now)}
        className={styles.countyForm}
        isHome={true}
        planBenefitPackages={props.planBenefitPackages}
        ssaCounties={props.ssaCounties}
        supportedCounties={props.supportedCounties}
      />
    </div>
  );
};

export default FindAPlan;

export const query = graphql`
  fragment pageFindAPlan on PrismicPageDataBodyFindAPlanForm {
    id
    slice_type
    primary {
      heading {
        text
      }
      form_label
      submit_button_label
    }
  }
`;
